import { render, staticRenderFns } from "./PendingPlanChangeModal.vue?vue&type=template&id=82b58818"
import script from "./PendingPlanChangeModal.vue?vue&type=script&lang=js"
export * from "./PendingPlanChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports